<!---分享面板-->
<template>
  <SharePanel
    :layerName="layerName"
    :hasRedPacket="hasRedPacket"
    :pageSource="pageSource"
    :shareChannelNames="['weixin', 'weixincircle', 'image', 'weibo']"
    @share="share"
    />
</template>
<script>
import shareManager from '../../services/share.manager';
import { mapGetters } from 'vuex';
import { URLService } from '../../services/url.service';
import * as queryConst from '../../services/query.const';
import layerManager from '../../services/layer.manager';
import * as layerNames from '../../services/layerName';
import SharePanel from './SharePanel.vue';
export default {
  props: {
    options: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  name: 'AutoAppSharePanel',
  components: {
    SharePanel
  },
  data () {
    return {
      layerName: layerNames.SHARE_PANEL
    };
  },
  computed: {
    ...mapGetters('frame', { 'threeDimensionCar': 'threeDimensionCar' }),
    ...mapGetters({
      hasRedPacket: 'intended/hasRedPacket'
    }),
    isShare3D () {
      return this.threeDimensionCar.show && this.threeDimensionCar.seriesId > 0;
    },
    pageSource () {
      return this.isShare3D ? '3dCar' : 'vr';
    }
  },
  methods: {
    share (channelName) {
      if (channelName === 'image') {
        this.emitImageShare();
      } else {
        this.emitNativeShare(channelName);
      }
    },
    emitNativeShare (platform) {
      const self = this;
      if (this.isShare3D) {
        const shareUrl = this.build3dCarShareUrl(this.threeDimensionCar.seriesId, 6845263);
        shareManager.showShare({
          isNative: true,
          hideMiniProgram: true,
          platform: platform,
          icon: 'https://x.autoimg.cn/dealer/vr/Resources/img/share-pano-200-200.png?v=1.0',
          title: `${this.threeDimensionCar.seriesName} 3D看车  想看哪里点哪里`,
          desc: '这里有一张车展的“趟票”',
          shareUrl: shareUrl
        });
      } else {
        shareManager.showShare({ isNative: true, platform: platform, shareUrl: self.options.shareUrl });
      }
    },
    build3dCarShareUrl (seriesId, pvareaId = 0) {
      const urlSerivce = new URLService(window.location.href);
      urlSerivce.fragment = '';
      urlSerivce.queryParams.append('openType', queryConst.QUERY_OPENTYPE_3DCAR).append('seriesId', seriesId)
        .remove('pvareaId');
      if (pvareaId !== 0) {
        urlSerivce.queryParams.append('pvareaid', pvareaId);
      }
      let shareUrl = urlSerivce.build();
      return shareUrl;
    },
    //触发首页海报分享
    emitImageShare () {
      const self = this;
      // self.close();

      if (this.isShare3D) {
        const shareUrl = this.build3dCarShareUrl(this.threeDimensionCar.seriesId, 0);
        layerManager.open(layerNames.SHARE_POST, {
          options: {
            sharePosterType: '3DCar', // 3DCar
            seriesId: this.threeDimensionCar.seriesId,
            url: encodeURIComponent(shareUrl)
          }
        });
      } else {
        layerManager.open(layerNames.SHARE_POST, {
          options: {
            sharePosterType: 'hall', // 3DCar
            type: self.options.type,
            activityType: self.options.activityType,
            activityId: self.options.activityId,
            giftId: self.options.giftId,
            number: self.options.number
          }
        });
      }
    }
  }
};
</script>
